module.exports = __webpack_public_path__ + "img/contact.6f2e0d41.jpg";